<section class="content profile-page">
  <div class="block-header">
      <div class="">
           <div class="row ">
             <div class="col-md-12 p-0">
              <h2 class="poppins font-weight-bold pl-2">Customer Virtual AccountInfo</h2>
             </div>
                <div class=" col-md-5 px-6 col-sm-12 p-0">
                  <div class="breadcrumb flat">
                      <a [routerLink]="['/home']">Home</a>
                      <a [routerLink]="['/PayOut/ManageVirtualAccount']">Manage  Virtual AccountInfo</a>
                      <a href="#" class="active"> View  Virtual AccountInfo</a>
                  </div>
                 </div>
                <div class="col-md-7">
                  <div class="float-right">  
                     
                      <button class="box-button mr-3"[routerLink]="['/PayOut/VirtualAccount']">New
                         Virtual AccountInfo</button>
                      <button class="box-button mr-3"  [routerLink]="['/PayOut/ManageVirtualAccount']">Manage Virtual AccountInfo </button>
                      <button [routerLink]="['/reports/transactions/summary']" class="box-button mr-3">Reports</button>
                       

                  </div>
              </div>
          </div>
      </div>

  </div>
  <div class="  ">
      <div class="row">
          <div class="col-md-12 p-0">
              <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                  <div class="row mx-0">
                      <div class="col-md-12">
                          <h4 class="font-weight-bold"> PayOut Customer Virtual AccountInfo Details</h4>
                      </div>

                  </div>
                  <div class="row mx-0">
                      <div class="col-md-7">
                        <div class=" ">
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"> <label>Payout Customerkey Id</label> </div>
                              
                              <div class="col-7 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}
                                                               </div>
                          </div>
                          <!-- <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"> <label>Payout Customerkey Id</label> </div>
                              
                              <div class="col-7 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}</div>
                          </div> -->
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"> <label>AccountNo</label>  </div>
                              
                              <div class="col-7 p-0 view-text"> {{rows.AccountNo}}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"> <label> AccountHolderName</label></div>
                              
                              <div class="col-7 p-0 view-text robot"> {{rows.AccountHolderName}}</div>
                          </div>
                        
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"> <label>Bank Code/IFSC Code </label>  </div>
                              
                              <div class="col-7 p-0 view-text"> {{rows.BankCode}}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                            <div class="col-4 p-0"> <label>BankCode Type </label>  </div>
                            
                            <div class="col-7 p-0 view-text"> {{rows.BankCodeType}}</div>
                        </div>
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"><label> Address </label>  </div>
                              
                              <div class="col-7 p-0 view-text robot"> {{rows.Address}}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"> <label> City </label>  </div>
                              
                              <div class="col-7 p-0 view-text"> {{rows.City}}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"> <label> State</label>  </div>
                              
                              <div class="col-7 p-0 view-text robot">   {{rows.State }}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"> <label>ZipCode</label>  </div>
                              
                              <div class="col-7 p-0 view-text robot"> {{rows.ZipCode}}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"><label> MobileNo </label>  </div>
                              
                              <div class="col-7 p-0 view-text robot"> {{rows.MobileNo}}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"><label>  MobileNotification</label> </div>
                              
                              <div class="col-7 p-0 view-text robot"> {{rows.MobileNotification}}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"><label> Email  </label> </div>
                              
                              <div class="col-7 p-0 view-text"> {{rows.Email}}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                              <div class="col-4 p-0"><label>  EmailNotification </label>  </div>
                              
                              <div class="col-7 p-0 view-text"> {{rows.EmailNotification}}</div>
                          </div>
                          <div class="row border-bottom p-1 m-3">

                            <div class="col-4 p-0"><label>  PayoutProcessor </label>  </div>
                            
                            <div class="col-7 p-0 view-text"> {{rows.PayoutProcessor}}</div>
                        </div>
                        <div class="row border-bottom p-1 m-3">

                          <div class="col-4 p-0"><label>  UpdatedDateTime </label>  </div>
                          
                          <div class="col-7 p-0 view-text"> {{rows.UpdatedDateTime | date:'d/M/yy, h:mm a'}}</div>
                      </div>
                      
                      <!-- <div class="row border-bottom p-1 m-3">

                        <div class="col-4 p-0"><label>  UpdatedUserName </label>  </div>
                        
                        <div class="col-7 p-0 view-text"> {{rows.UpdatedUserName}}</div>
                    </div> -->



                    <div class="text-right pt-2">
                                         
                      <button class="btn box-button px-4 py-2" 
                        id="Savecoupon" color="primary" 
                        (click)="openConfirmationDialog()"
                        >Delete </button>
                                             </div>



                    <div class="row m-1 text-right">
                             
                            
                          </div>
                      </div>
                      </div>
                      <div class="col-md-5">
                          <div class="b">
                              <img src="assets/img/collecting-money.png" alt="Tips"
                                  style="display: block; width: 100%;">
                          </div>
                          
                      </div>



                   
              </div>
          </div>
      </div>
  </div>

 
  </div>
</section>
 